const createActions = (base) => [
  `${base}_REQUEST`,
  `${base}_SUCCESS`,
  `${base}_ERROR`
];
export const createActionsCurried = (prefix) => (base) =>
  createActions(`${prefix}/${base}`);
